export enum Location {
  POP_UP = 'create_account_modal',
}

export enum Vendor {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}
